function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 4l8 8-8 8-1.42-1.42L16.17 13H4v-2h12.17l-5.58-5.59z"
});

var SvgArrowNext = function SvgArrowNext(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGc+CiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0xMiA0TDIwIDEyIDEyIDIwIDEwLjU4IDE4LjU4IDE2LjE3IDEzIDQgMTMgNCAxMSAxNi4xNyAxMSAxMC41OSA1LjQxeiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgArrowNext as ReactComponent };